<div class="max-w-xxl mx-auto mt-10 p-6 bg-white shadow rounded">
  <form class="max-w-md mx-auto" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="mb-4">
      <label class="block mb-1">Email</label>
      <input type="email" formControlName="email" class="w-full border p-2 rounded" />
      <p *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="text-red-500 text-sm">Enter valid email</p>
    </div>

    <div class="mb-4">
      <label class="block mb-1">Password</label>
      <input type="password" formControlName="password" class="w-full border p-2 rounded" />
      <p *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="text-red-500 text-sm">Required</p>
    </div>

    <div class="mb-4 flex items-center">
      <input type="checkbox" formControlName="simulateLowScore" class="mr-2" />
      <label class="block mb-1">Simulate with Low Score</label>
    </div>
    <button type="submit" class="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700">Login</button>
    <button type="button" class="bg-fuchsia-700 w-full mt-3 text-white px-4 py-2 rounded hover:bg-fuchsia-900" (click)="submitReferralWithoutToken()">
      Login Without Token
    </button>
  </form>

  @if(loginForm.valid && captchaResponse) {
    <div class="mt-4">
      <h2 class="text-lg font-bold">Captcha Details</h2>
      <pre>{{ captchaResponse | json }}</pre>
    </div>
  }
  @if(captchaError) {
    <div class="mt-4">
      <pre class="text-red-500 text-sm">{{captchaError.error | json }}</pre>
    </div>
  }
</div>
